import { Navigate } from 'react-router-dom'
// 用路由懒加载优化加载性能
import Layout from '@/pages/layout'
import SimpleLayout from '@/pages/layout/simple-layout'
import Home from '@/pages/home'
import Login from '@/pages/login'
import NotFound from '@/pages/notfound'
import Dashboard from '@/pages/dashboard' // 新增
import { KeepAlive } from 'react-activation'
// import Test1 from '@/pages/Custom/Test1'
// import Test2 from '@/pages/Custom/Test2'
// import Test3 from '@/pages/Custom2/Test1'
// import Test4 from '@/pages/Custom2/Test2'
// import Bot from '@/pages/bot'
// import Flow from '@/pages/flow'
// import BotWorkflow from '@/pages/bot/workflow'
// import FlowWorkflow from '@/pages/flow/workflow'
import { ComponentType, createElement, lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { getDefaultHomePath } from '@/constants/menuPermission'
import AILogin from '@/pages/login/ailogin'
import BatchCall from '@/pages/batchcall'
import CallDetail from '@/pages/calldetail'
import Bill from '@/pages/bill'
import WebtalkDetail from '@/pages/webtalkDetail'
import Channel from '@/pages/chatbot/channel'
import LiveChat from '@/pages/chatbot/liveChat'
import ChatDetail from '@/pages/chatbot/chatDetail'
import Broadcast from '@/pages/chatbot/broadcast'
import ChatbotOverview from '@/pages/chatbot/overview'
import Loading from '@/components/base/loading'
import AiccRouteBoundary from '@/next/AiccRouteBoundary'
import NextLogin from '@/next/NextLogin'
import { isLlmbotNext } from '@/next/runtime.mjs'
const PdsTaskList = lazy(() => import('@/next/PdsTaskList'))
const PhoneWorkspace = lazy(() => import('@/next/PhoneWorkspace'))
const CollaborationRecords = lazy(() => import('@/next/CollaborationRecords'))
const AiccSettings = lazy(() => import('@/next/AiccSettings'))
const OperationsOverview = lazy(() => import('@/next/OperationsOverview'))
const globalLazy = true

const NextRouteLoading = () => <Loading type="app" />

function PdsTaskRoute() {
  return <AiccRouteBoundary><Suspense fallback={<NextRouteLoading />}><PdsTaskList /></Suspense></AiccRouteBoundary>
}

function CollaborationRecordsRoute() {
  return <AiccRouteBoundary><Suspense fallback={<NextRouteLoading />}><CollaborationRecords /></Suspense></AiccRouteBoundary>
}

function AiccSettingsRoute() {
  return <AiccRouteBoundary><Suspense fallback={<NextRouteLoading />}><AiccSettings /></Suspense></AiccRouteBoundary>
}

function OperationsOverviewRoute() {
  return <AiccRouteBoundary><Suspense fallback={<NextRouteLoading />}><OperationsOverview /></Suspense></AiccRouteBoundary>
}

function PhoneWorkspaceRoute({ mode }: { mode: 'auto' | 'collaboration' }) {
  return <AiccRouteBoundary><Suspense fallback={<NextRouteLoading />}><PhoneWorkspace mode={mode} /></Suspense></AiccRouteBoundary>
}

function LoginRoute() {
  return isLlmbotNext(process.env) ? <NextLogin /> : <Login />
}

const _import = (path: string, dynamic?: boolean) => {
  // 启用动态导入进行代码分割
  return lazy(() => import(`@/pages/${path}`) as Promise<{
    default: ComponentType<any>
  }>)

  // 如果需要禁用懒加载可以使用同步导入（会增加 bundle 大小）
  // return require(`@/pages/${path}`).default
}
const lazyImport = (
  path: string,
  options?: {
    keepAlive?: boolean
    lazy?: boolean
  }
) => {
  const LazyComponent = _import(path, false)

  // 创建一个包装组件来正确处理 lazy 和 Suspense
  const Wrapper = (props: any) => {
    const loadingFallback = (
      <div className="flex justify-center items-center w-full h-screen bg-[#090A0D]">
        <Loading type="app" />
      </div>
    )

    if (!options?.keepAlive) {
      return (
        <Suspense fallback={loadingFallback}>
          <LazyComponent {...props} />
        </Suspense>
      )
    }

    return (
      <KeepAlive cacheKey={path} name={path}>
        <Suspense fallback={loadingFallback}>
          <LazyComponent {...props} key={path} />
        </Suspense>
      </KeepAlive>
    )
  }

  return createElement(Wrapper)
}

function DefaultRedirect() {
  const userInfo = useSelector((state: any) => state.user.userInfo)
  if (!userInfo) return <NextRouteLoading />
  const defaultPath = getDefaultHomePath(userInfo.menus, userInfo)
  return <Navigate to={defaultPath} replace />
}

const constantRoutes = [
  { path: '/login', title: '登录', element: <LoginRoute /> },
  { path: '/ailogin', title: 'AI登录', element: <AILogin />, hidden: true }, // 修正路径
  {
    path: '/',
    title: 'Home',
    hidden: true,
    element: <Layout />,
    children: [
      { index: true, element: <DefaultRedirect /> },
      ...(process.env.LLMBOT_NEXT === true ? [
        { path: 'aicc/overview', title: 'Overview', hidden: true,
          element: <OperationsOverviewRoute /> },
        { path: 'aicc/settings', title: 'Voice Settings', hidden: true,
          element: <AiccSettingsRoute /> },
        {
          path: 'aicc/pds/tasks',
          title: 'Outbound Tasks',
          element: <PdsTaskRoute />,
          hidden: true,
        },
        {
          path: 'aicc/pds/agent',
          title: 'PD Agent Desk',
          element: <PhoneWorkspaceRoute mode="auto" />,
          hidden: true,
        },
        {
          path: 'aicc/collaboration',
          title: 'AI Handoff Desk',
          element: <PhoneWorkspaceRoute mode="collaboration" />,
          hidden: true,
        },
        {
          path: 'aicc/collaboration/records',
          title: 'Handoff Records',
          element: <CollaborationRecordsRoute />,
          hidden: true,
        },
      ] : []),
      // hidden:false代表要显示在侧边导航栏，其余皆不显示
      {
        path: 'home',
        title: 'Home',
        element: <Home />,
        hidden: false,
        icon: 'home'
      },
      // 新增dashboard路由
      {
        path: 'dashboard',
        title: 'Dashboard',
        element: <Dashboard />,
        hidden: false,
        icon: 'dashboard'
      },
      {
        path: 'chatbot-overview',
        title: 'Chatbot Overview',
        element: <ChatbotOverview />,
        hidden: false,
        icon: 'overview-cb'
      },
      {
        path: 'batch-call',
        title: 'Batch Call',
        element: <BatchCall />,
        hidden: false,
        icon: 'batchcall'
      },
      {
        path: 'call-detail',
        title: 'Call Detail',
        element: <CallDetail />,
        hidden: false,
        icon: 'calldetail'
      },
      {
        path: 'bill',
        title: 'Bill',
        element: <Bill />,
        hidden: false,
        icon: 'bill'
      },
      {
        path: 'webtalk-detail',
        title: 'Talk Detail',
        element: <WebtalkDetail />,
        hidden: false,
        icon: 'webtalk-detail'
      },
      {
        path: 'channel',
        title: 'Channel',
        element: <Channel />,
        hidden: false,
        icon: 'channel'
      },
      {
        path: 'live-chat',
        title: 'Live Chat',
        element: (
          <KeepAlive name="live-chat" cacheKey="chatbot/liveChat">
            <LiveChat />
          </KeepAlive>
        ),
        hidden: false,
        icon: 'Livechat'
      },
      {
        path: 'chat-detail',
        title: 'Chat Detail',
        element: <ChatDetail />,
        hidden: false,
        icon: 'chatdetail'
      },
      {
        path: 'broadcast',
        title: 'Broadcast',
        element: <Broadcast />,
        hidden: false,
        icon: 'broadcast'
      }
    ]
  },
  {
    title: 'tool',
    path: 'tool',
    // redirect: '/flow-workflow',
    hidden: true,
    element: <SimpleLayout />,
    menuPath: '',
    children: [
      {
        path: '',
        title: 'tool-index',
        element: lazyImport('flow/workflow')
      }
    ]
  },
  {
    title: 'bot',
    path: 'bot',
    // redirect: '/bot-workflow',
    hidden: true,
    element: <SimpleLayout />,
    menuPath: '',
    children: [
      {
        path: '',
        title: 'bot-index',
        element: lazyImport('bot/workflow')
      }
    ]
  },
  {
    title: 'Knowledge Base Detail',
    path: '/knowledge-base/detail/:id',
    hidden: true,
    element: <Layout />,
    menuPath: '/knowledge-base',
    children: [
      {
        index: true,
        title: 'kb-detail',
        element: lazyImport('knowleageBase/detail')
      }
    ]
  },
  {
    title: 'Session Detail',
    path: '/chat-detail/session/:id',
    hidden: true,
    element: <Layout />,
    menuPath: '/chat-detail',
    children: [
      {
        index: true,
        title: 'session-detail',
        element: lazyImport('chatbot/chatDetail/component/sessionDetail')
      }
    ]
  },
  {
    title: 'Broadcast Detail',
    path: '/broadcast/detail/:id',
    hidden: true,
    element: <Layout />,
    menuPath: '/broadcast',
    children: [
      {
        index: true,
        title: 'broadcast-detail',
        element: lazyImport('chatbot/broadcast/component/detail')
      }
    ]
  },
  { path: '*', title: '404页面', element: <NotFound /> }
]

export const menuData = [
  {
    title: 'LLM Bot',
    // icon: 'llm_bot',
    // icon: 'bot-icon',
    icon: 'bots',

    component: lazyImport('bot', {
      keepAlive: true
    }),
    // <KeepAlive name="botstudio">{}</KeepAlive>
    path: 'bots',
    redirect: '/bots',
    hidden: false,
    menuPath: '/bots'
  },
  {
    title: 'Tools',
    // icon: 'flow_tool',
    // icon: 'flowtool',
    icon: 'tools',
    component: lazyImport('flow', {
      keepAlive: true
    }),
    // <KeepAlive name="flowstudio">{)}</KeepAlive>
    path: 'tools',
    redirect: '/tools',
    hidden: false,
    menuPath: '/tools'
  },
  {
    title: 'Knowledge Base',
    icon: 'knowledge-base',
    component: lazyImport('knowleageBase', {
      keepAlive: true
    }),
    path: 'knowledge-base',
    redirect: '/knowledge-base',
    hidden: false,
    menuPath: '/knowledge-base'
  }
]
export default constantRoutes
